import * as Sentry from '@sentry/browser';
import { pathToRegexp } from 'path-to-regexp';

/**
 * https://github.com/pillarjs/path-to-regexp#errors
 *
 * There could be more scenarios that we might want to add.
 */
function parseAmbiguousPath(url: string) {
  let parsedUrl = url;

  if (url.includes('*')) {
    parsedUrl = parsedUrl.replaceAll('*', '{/*path}');
  }

  return parsedUrl;
}

export function isUrlAllowed(urls: string[] | undefined, path: string) {
  if (!urls) {
    return false;
  }
  try {
    return urls.some((url: string) => pathToRegexp(parseAmbiguousPath(url)).regexp.test(path));
  } catch (e) {
    Sentry.captureException(e);
    return false;
  }
}
